<template>
  <ion-page class="essay-generate flex-column align-center" @click.stop="closePop">
    <textarea ref="essayCopyRef" class="clipboard-copy"></textarea>
    <!--标题 & 返回按钮 & 右上角参数图标-->
    <div class="essay-generate_header flex-row align-center justify-between mb-3">
      <img
        class="essay-generate_header-back cursor-pointer"
        :src="getBrandImageUrl('ai_smart_reading/nav_back.png')"
        alt=""
        @click="onClose"
      />
      <div class="right-bar flex-row flex-shrink-0">
        <div
          v-if="isReadOrOriginal && [1, 2].includes(readType)"
          class="flex-column align-center justify-center"
          @click="changeNewReadingArticlePrepare"
        >
          <i
            class="iconfont icon-yuedulijie right-bar_icon cursor-pointer"
            style="font-size: 1.7rem; width: auto; line-height: 0.96"
          ></i>
        </div>
        <div
          title="全文复制"
          class="right-bar_icon cursor-pointer ml-4"
          @click="copyContent('全文复制')"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes('全文复制') }"
            src="@/assets/teacher_index/version5/copy_icon.png"
            alt=""
          />
        </div>
        <div
          title="段落翻译"
          class="right-bar_icon cursor-pointer ml-4"
          @click="showTranslation('段落大意')"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes('段落大意') }"
            src="@/assets/teacher_index/version5/reading_icon_3.svg"
            alt=""
          />
        </div>
        <div
          title="逐句翻译"
          class="right-bar_icon cursor-pointer ml-4"
          @click="showTranslation2('逐句翻译')"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes('逐句翻译') }"
            src="@/assets/teacher_index/version5/reading_icon_4.svg"
            alt=""
          />
        </div>
        <div
          title="段落大意"
          class="right-bar_icon cursor-pointer ml-4"
          @click="showKnowledge('知识点')"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes('知识点') }"
            src="@/assets/teacher_index/version5/reading_icon_5.svg"
            alt=""
          />
        </div>
        <div
          class="right-bar_icon cursor-pointer ml-4"
          title="答题解析"
          @click="showExamination('测试题')"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes('测试题') }"
            src="@/assets/teacher_index/version5/reading_icon_6.svg"
            alt=""
          />
        </div>

        <div
          class="right-bar_icon cursor-pointer ml-4"
          title="句子定位"
          @click="showFocus('句末焦点')"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes('句末焦点') }"
            src="@/assets/teacher_index/version5/reading_icon_7.svg"
            alt=""
          />
        </div>

        <div
          title="句子转换"
          class="right-bar_icon cursor-pointer ml-4 mr-4"
          @click="showNextFocus('自动定位')"
        >
          <img
            class="normal-img"
            :class="{ 'clicked-img': clickedArr.includes('自动定位') }"
            src="@/assets/teacher_index/version5/reading_icon_8.svg"
            alt=""
          />
        </div>

        <div class="right-bar_drop cursor-pointer" title="字号切换">
          <img
            class="normal-img"
            src="@/assets/teacher_index/version5/reading_icon_9.svg"
            alt=""
            @click="changeFontSize"
          />
          <div
            class="right-bar_drop_options flex-column"
            :class="{ options_active: selectOptionsVisible }"
          >
            <span
              v-for="(size, index) in ['小', '中', '大']"
              :key="index"
              :class="{ 'checked-size': currentSize === size }"
              @click="changeFontStyle(size)"
              >{{ size }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!--markdown文章-->
    <div class="essay-generate_main flex-column align-center">
      <div v-if="isReadOrOriginal">
        <!--暂停播放-->
        <p v-if="audioStatus === 'playing'" class="audio-play" @click="fullTextAudioStop">
          <i class="iconfont icon-zanting"></i>
        </p>
        <!--播放全文-->
        <p v-else class="audio-play" @click="allSentenceAudioPlay">
          <i class="iconfont icon-bofang3"></i>
        </p>
      </div>
      <div class="essay-generate_content">
        <ion-content>
          <div class="">
            <h2 class="title english-font1">{{ dataObject.title }}</h2>
            <p class="translation3">
              <span class="titleTranslation">{{ dataObject.titleTranslation }}</span>
            </p>
            <!--教案-->
            <div class="articleBody"></div>
            <div id="examination" class="examination mb-5"></div>
            <div id="knowledge" class="knowledge"></div>
          </div>
        </ion-content>
      </div>
    </div>
  </ion-page>
  <AnswerPop
    v-if="!examinationVisible"
    v-model:show="answerPopVisible"
    :answer-pop-data="answerPopId"
    :reading-id="readingId"
    :student-id="store.getStudentId()"
  ></AnswerPop>
</template>

<script>
/* eslint-disable */

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonToolbar,
  modalController,
  popoverController,
  toastController,
} from "@ionic/vue"

import TextComponent from "@/components/MarkdownText.vue"
import { chevronBackOutline,toggleOutline } from "ionicons/icons"
import Popover from "./Popover.vue"
import ReadingPersonalVocabulary from "./ReadingPersonalVocabulary.vue"
import Five from "@/views/speed/Five"
import Nine from "@/views/speed/Nine"
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import AnswerPop from "@/views/reading/AnswerPop.vue"
import { openMsgToast } from "@/views/AIGenerate/openModal"
import { textToPlayAudio } from "@/js/textToPlayAudio"
import NewReadingArticle from "@/views/reading/newReadingArticle/ArticleIndex.vue"
import store from "@/js/store"
function myCreateElement(str, ...cls) {
  let el = document.createElement(str)
  el.classList.add(...cls)
  return el
}

export default {
  name: "ReadingArticle",
  props: ["readingId", "isReadOrOriginal","readType"],
  components: {
    AnswerPop,
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonButtons,
    IonIcon,
    TextComponent,
  },
  setup() {
    return {
      chevronBackOutline,
      toggleOutline,
    }
  },

  data() {
    return {
      dataObject: {},
      translationVisible: true, //翻译展示开关
      translationVisible2: true, //翻译展示开关
      knowledgeVisible: true, //知识点展示开关
      examinationVisible: true, //测试题展示开关
      focusVisible: true, //句子焦点展示开关
      switchTranslationText: "显示翻译",
      timerTouchstart: undefined, //模拟长按事件定时器

      strTime1: "10:00",
      strTime2: "00:00",
      timerUnlock1: 600,
      timerUnlock2: 0,
      buttonVisible: true,

      examinationDataTable: [], //完形填空测试题答案对照表
      brandImages: BRAND_IMAGES, // 品牌图片数据
      selectOptionsVisible: false,
      fontStyle: { "font-size": "1.1em" },
      clickedArr: [], // 点击的操作图标数组
      currentSize: "小",
      answerPopVisible: false,
      answerPopId: null,
      ossAudioPlayer: null,
      audioStatus: "",
      bofangTimer: null,
    }
  },

  methods: {
    getBrandImageUrl,
    changeFontSize() {
      this.selectOptionsVisible = !this.selectOptionsVisible
    },

    handleClickedFunction(str) {
      // 两个翻译冲突，显示一个另一个不显示
      if (str === "段落大意") {
        this.clickedArr = this.clickedArr.filter((i) => i !== "逐句翻译")
      } else if (str === "逐句翻译") {
        this.clickedArr = this.clickedArr.filter((i) => i !== "段落大意")
      }
      if (this.clickedArr.includes(str)) {
        this.clickedArr.splice(this.clickedArr.indexOf(str), 1)
      } else {
        this.clickedArr.push(str)
      }
    },

    changeFontStyle(size) {
      this.currentSize = size
      if (size === "小") {
        this.setFontSize("english-font1")
      } else if (size === "中") {
        this.setFontSize("english-font2")
      } else if (size === "大") {
        this.setFontSize("english-font3")
      }
      this.changeFontSize()
    },

    //弹出"继续练习"，"结束资料"对话框
    async myAlert() {
      return new Promise(async (resolve) => {
        const alert = await alertController.create({
          header: "",
          message: "确认退出？",
          backdropDismiss: false,
          buttons: [
            {
              text: "退出备课",
              handler: () => {
                resolve(true)
              },
            },
            {
              text: "继续备课",
              handler: () => {
                resolve(false)
              },
            },
          ],
        })
        await alert.present()
      })
    },

    async onClose() {
      if (this.isReadOrOriginal) {
        this.fullTextAudioStop()
        await modalController.dismiss().then(() => {
          console.log("onClose")
          this.fullTextAudioStop()
        })
      } else {
        if (await this.myAlert()) {
          await modalController.dismiss()
        } else {
          await alertController.dismiss()
        }
      }
    },

    //开始一篇文章的练习
    startReadingArticleLearning() {
      const appointment = this.store.getAppointment()
      this.ajax.post("/reading/startReadingArticleLearning", {
        readingId: this.readingId,
        studentId: appointment.studentId,
      })
    },

    //#######################  创建抗遗忘 #####################

    setFontSize(cssClass) {
      document.querySelectorAll(".english").forEach((el) => {
        el.classList.remove("english-font1")
        el.classList.remove("english-font2")
        el.classList.remove("english-font3")
        el.classList.add(cssClass)
      })
      document.querySelectorAll(".translation").forEach((el) => {
        el.classList.remove("english-font1")
        el.classList.remove("english-font2")
        el.classList.remove("english-font3")
        el.classList.add(cssClass)
      })
      const titleDom = document.querySelector(".title")
      const titleTranslationDom = document.querySelector(".titleTranslation")
      for (let i of ["english-font1", "english-font2", "english-font3"]) {
        titleDom.classList.remove(i)
        titleTranslationDom.classList.remove(i)
      }
      titleDom.classList.add(cssClass)
      titleTranslationDom.classList.add(cssClass)
    },

    async openPopover(ev, word) {
      const popover = await popoverController.create({
        component: Popover,
        componentProps: { word: word, readingId: this.readingId },
        event: ev,
        translucent: true,
        cssClass: "popover_class",
      })
      await popover.present()
      //const {role} = await popover.onDidDismiss();
      await popover.onDidDismiss()
      ev.target.classList.remove("focusWord")
    },

    async openReadingPersonalVocabulary() {
      const modal = await modalController.create({
        component: ReadingPersonalVocabulary,
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    changeCourse() {
      return new Promise((resolve) => {
        const appointment = this.store.getAppointment()
        this.ajax
          .post("/course/changeCourseReading", { aptmId: appointment.aptmId })
          .then((res) => {
            if (res.data.success) {
              resolve()
            }
          })
      })
    },

    //打开9宫格，开始上课
    async openNine() {
      await this.changeCourse()
      let studentId = this.store.getStudentId()
      const modal = await modalController.create({
        component: Nine,
        componentProps: { studentId: studentId, readingId: this.readingId },
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    //打开5滴图，开始上课
    async openSpeedIndex() {
      let studentId = this.store.getStudentId()
      const modal = await modalController.create({
        component: Five,
        componentProps: { studentId: studentId },
        cssClass: "modal_controller_class",
      })

      this.inClass = true
      await modal.present()
      await modal.onDidDismiss()
      this.inClass = false
    },

    //滚动到焦点处
    scrollToFocus() {
      const contentList = document.querySelectorAll(".content")
      for (let i = 0; i < contentList.length; i++) {
        if (contentList[i].classList.contains("contentFocus")) {
          contentList[i].scrollIntoView(false)
          break
        }
      }
    },

    //切换到阅读课备课模式
    async changeNewReadingArticlePrepare(){
     const modal = await modalController.create({
        component: NewReadingArticle,
        componentProps: { readingId: this.readingId, fromPrepareOrigin: true,readType:this.readType },
        cssClass: "modal_controller_class",
      });
      modalController.dismiss()
      await modal.present()
    },

    async copyContent() {
      // 获取标题
      const title = this.dataObject.title || ""

      // 获取文章正文内容（从DOM中提取纯文本）
      const articleText = this.dataObject.essayContent

      // 组合完整的文本
      const textToCopy = title + "\n\n" + articleText

      if (!textToCopy.trim()) {
        await openMsgToast("没有可复制的内容")
        return
      }

      try {
        // 优先使用现代 Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(textToCopy)
          await openMsgToast("复制成功")
        } else {
          // 降级到传统方法
          const textarea = this.$refs.essayCopyRef
          textarea.value = textToCopy
          textarea.style.position = "absolute"
          textarea.style.left = "0"
          textarea.style.top = "0"
          textarea.style.opacity = "0"
          textarea.style.zIndex = "-1"

          textarea.select()
          textarea.setSelectionRange(0, textToCopy.length)

          const successful = document.execCommand("copy")
          if (successful) {
            await openMsgToast("复制成功")
          } else {
            await openMsgToast("复制失败")
          }

          textarea.style.left = "-9999px"
        }
      } catch (err) {
        console.error("复制失败:", err)
        await openMsgToast("复制失败")
      }
    },

    //2合1，控制翻译是否显示
    showTranslation(str) {
      // 记录点击功能图标
      this.handleClickedFunction(str)

      //激活另一个按钮
      this.translationVisible2 = true

      //无翻译在显示
      if (this.translationVisible) {
        this.translationVisible = false
        document.querySelectorAll(".translation").forEach((node) => {
          node.classList.add("translation-show")
        })
        document.querySelector(".translation3").classList.add("translation-show")

        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.remove("translation-show")
        })
      }

      //有翻译在显示
      else {
        this.translationVisible = true

        document.querySelector(".translation3").classList.remove("translation-show")

        document.querySelectorAll(".translation").forEach((node) => {
          node.classList.remove("translation-show")
        })

        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.remove("translation-show")
        })
      }

      this.scrollToFocus()
    },

    showTranslation2(str) {
      // 记录点击功能图标
      this.handleClickedFunction(str)

      //激活另一个按钮
      this.translationVisible = true

      //无翻译在显示
      if (this.translationVisible2) {
        this.translationVisible2 = false
        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.add("translation-show")
        })
        document.querySelector(".translation3").classList.add("translation-show")

        document.querySelectorAll(".translation").forEach((node) => {
          node.classList.remove("translation-show")
        })
      }

      //有翻译在显示
      else {
        this.translationVisible2 = true
        document.querySelector(".translation3").classList.remove("translation-show")
        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.remove("translation-show")
        })

        document.querySelectorAll(".translation2").forEach((node) => {
          node.classList.remove("translation-show")
        })
      }
      this.scrollToFocus()
    },

    //显示知识点
    showKnowledge(str) {
      // 记录点击功能图标
      this.handleClickedFunction(str)
      if (document.querySelector(".knowledge-show")) {
        this.knowledgeVisible = true
        document.querySelectorAll(".knowledge").forEach((node) => {
          node.classList.remove("knowledge-show")
        })
      } else {
        this.knowledgeVisible = false
        document.querySelectorAll(".knowledge").forEach((node) => {
          node.classList.add("knowledge-show")
        })
      }

      this.scrollToFocus()
    },

    //显示消息
    async toastMessage(message) {
      const toast = await toastController.create({
        message: message,
        duration: 1000,
        position: "middle",
        color: "success",
      })
      await toast.present()
    },

    //显示测试题
    showExamination(str) {
      // 记录点击功能图标
      this.handleClickedFunction(str)
      if (document.querySelector(".examination-show")) {
        this.examinationVisible = true
        document.querySelectorAll(".examination").forEach((node) => {
          node.classList.remove("examination-show")
        })

        this.toastMessage("测试题已关闭。")
      } else {
        this.examinationVisible = false
        document.querySelectorAll(".examination").forEach((node) => {
          node.classList.add("examination-show")
        })

        //页面直接滚动到指定位置
        document.querySelector("#examination").scrollIntoView(true)
        this.toastMessage("测试题已显示在文章最下方。")
      }
    },

    //显示测试题
    showFocus(str) {
      // 记录点击功能图标
      this.handleClickedFunction(str)

      if (document.querySelector(".sentence-focus-show")) {
        this.focusVisible = true
        document.querySelectorAll(".sentence-focus").forEach((node) => {
          node.classList.remove("sentence-focus-show")
        })
      } else {
        this.focusVisible = false
        document.querySelectorAll(".sentence-focus").forEach((node) => {
          node.classList.add("sentence-focus-show")
        })

        document.querySelectorAll(".content").forEach((node2) => {
          node2.classList.remove("contentFocus")
        })
      }

      this.scrollToFocus()
    },

    showNextFocus(str) {
      // 记录点击功能图标
      this.clickedArr.push(str)

      const contentList = document.querySelectorAll(".content")
      let exist = false
      for (let i = 0; i < contentList.length; i++) {
        //存在焦点
        if (contentList[i].classList.contains("contentFocus")) {
          exist = true
          contentList[i].classList.remove("contentFocus")
          if (i == contentList.length - 1) {
            contentList[0].classList.add("contentFocus")
            contentList[0].scrollIntoView(false)
          } else {
            contentList[i + 1].classList.add("contentFocus")
            contentList[i + 1].scrollIntoView(false)
          }
          break
        }
      }

      if (!exist && contentList.length > 0) {
        contentList[0].classList.add("contentFocus")
        contentList[0].scrollIntoView(false)
      }
    },

    //  完形填空  -- 开始
    async showExaminationOptionTable(ev, idx) {
      // const modal = await modalController.create({
      //   component: ModalExamOptions,
      //   componentProps: { examData: this.examinationDataTable[idx] },
      //   cssClass: "common_center_modal_class modal_examination_class",
      // });
      // await modal.present();
      this.closePop()
      setTimeout(() => {
        this.answerPopVisible = true
        this.answerPopId = this.examinationDataTable[idx]
      }, 300)
    },
    closePop() {
      if (this.answerPopVisible) {
        this.answerPopVisible = false
      }
    },
    //处理测试题
    handleExamination(examination) {
      if (!examination) {
        return
      }

      this.examinationDataTable = []

      //找出题目标号
      examination = examination.replace(/\(\s*(\d\d*)\s*\)/gi, (search, p1) => {
        this.examinationDataTable[p1] = { idx: search }
        return `<span class="examination-number" data-idx="${p1}">${search}</span>`
      })

      //找出选项的数字标号，后续还需找出4个选项
      examination = examination.replace(/(\d\d*)\s*、/gi, (search, p1) => {
        return `<span id="examination-option${p1}" class="examination-option">${search}</span>`
      })

      //找出答案
      examination = examination.replace(/【\s*(\d\d*)\s*】/gi, (search, p1) => {
        return `<span id="examination-answer${p1}" class="examination-answer">${search}</span>`
      })

      let elExamination = document.getElementById("examination")

      //向页面输出测试题
      elExamination.innerHTML = examination

      //给题目标号绑定点击事件
      elExamination.querySelectorAll(".examination-number").forEach((node1) => {
        node1.addEventListener("click", (ev) => {
          this.showExaminationOptionTable(ev, node1.dataset.idx)
        })
      })

      this.examinationDataTable.forEach((obj, idx) => {
        //根据选项标号找出4个选项，并保存
        let elExaminationOption = document.getElementById("examination-option" + idx)
        let elTableOption = myCreateElement("table", "examination-option-table")
        if (elExaminationOption) {
          let elExaminationOptionTR = elExaminationOption.closest("tr")
          if (elExaminationOptionTR) {
            elTableOption.appendChild(elExaminationOptionTR.cloneNode(true))
            if (elExaminationOptionTR.nextElementSibling) {
              elTableOption.appendChild(elExaminationOptionTR.nextElementSibling.cloneNode(true))
            }
          }
        }
        this.examinationDataTable[idx].option = elTableOption

        //根据标号找出答案
        let elExaminationAnswer = document.getElementById("examination-answer" + idx)
        if (elExaminationAnswer) {
          let elExaminationAnswerTD = elExaminationAnswer.closest("td")
          elExaminationAnswerTD.style.width = "33.3%"
          this.examinationDataTable[idx].answer = elExaminationAnswerTD.innerHTML
        }
      })
    },

    //  完形填空  -- 结束

    //查询阅读理解文章
    queryReadingArticle() {
      this.ajax.post("/reading/getReadingArticleForApp?readingId=" + this.readingId).then((res) => {
        if (res.data.success) {
          //取到文章对象，赋给全局对象，展示英文标题，填充中文标题
          this.dataObject = res.data.data
          let article = res.data.data

          document.getElementById("knowledge").innerHTML = article.knowledge

          this.handleExamination(article.examination)

          let articleBody = document.querySelector(".articleBody")
          articleBody.innerHTML = ""

          //遍历段落
          article.sectionList.forEach((section) => {
            //创建段落标签
            let sectionDiv = myCreateElement("div", "section")

            //创建英文段落
            let english = myCreateElement("p", "english", "english-font1")
            let indent1 = myCreateElement("span", "indent") //缩进
            english.appendChild(indent1)

            //创建中文段落
            let translation = myCreateElement("p", "translation", "english-font1")
            let indent2 = myCreateElement("span", "indent") //缩进
            translation.appendChild(indent2)

            //遍历段落中的句子
            if (section.sentenceList) {
              section.sentenceList.forEach((sentence) => {
                let sentenceContent = myCreateElement("span", "content")
                sentenceContent.id = "content_" + sentence.sentenceId

                //创建每一句单独的翻译
                let sentenceTranslation2 = myCreateElement("p", "translation2")
                let content = sentence.content
                sentenceTranslation2.innerText = sentence.translation

                //匹配短语
                if (res.data.readingPhraseList) {
                  res.data.readingPhraseList.forEach((phrase) => {
                    let reg1 = phrase.content.replace(
                      "…",
                      "([a-zA-Z]+)([-'‘’][a-zA-Z]+)?( ([a-zA-Z]+)([-'‘’][a-zA-Z]+)?)*"
                    )
                    let reg = new RegExp(reg1, "gi")
                    content = content.replace(reg, (search) => {
                      return `<span class="phrase" data="${phrase.content}">${search}</span>`
                    })
                  })
                }

                //匹配重点单词，指定词库单词
                if (res.data.list) {
                  res.data.list.forEach((word) => {
                    let reg = new RegExp(
                      "(?<!<span.*)(?<![a-zA-Z]+)(" + word.content + ")(?![a-zA-Z]+)",
                      "gi"
                    )
                    content = content.replace(reg, (search) => {
                      return `<span class="course">${search}</span>`
                    })
                  })
                }

                //为每一个单词打上标记，并绑定事件
                content = content.replace(
                  /(?<!<[^>]*?)([a-zA-Z]+)([-'‘’][a-zA-Z]+)?/gim,
                  (search) => {
                    return `<span class="word">${search}</span>`
                  }
                )

                sentenceContent.innerHTML = content

                //在每一句后面插入焦点图标
                let focusFlag = myCreateElement("img", "sentence-focus")
                focusFlag.src =
                  store.getOEMBASE() + store.getOEMKEY() + "/app/focus-off.png"
                sentenceContent.appendChild(focusFlag)

                //.appendChild(sentenceTranslation2);//为每一句英文后面加上中文翻译
                english.appendChild(sentenceContent) //
                english.appendChild(sentenceTranslation2) //为每一句英文后面加上中文翻译

                let sentenceTranslation = myCreateElement("span", "sentence-translation")
                sentenceTranslation.innerText = sentence.translation
                translation.appendChild(sentenceTranslation)
              })
            }

            //在每一段后面插入一个操作图片
            //let sectionFlag = myCreateElement("img", "section-flag");
            //sectionFlag.src = "https://ydl-static.oss-cn-hangzhou.aliyuncs.com/images/lixiao/app/flag-red.png"
            //english.appendChild(sectionFlag);

            sectionDiv.appendChild(english)
            sectionDiv.appendChild(translation)

            //创建段落教案
            if (section.knowledge && section.knowledge.trim() != "") {
              let knowledge = myCreateElement("p", "knowledge")
              knowledge.classList.add("knowledge" + section.sectionId)
              knowledge.innerHTML = section.knowledge
              sectionDiv.appendChild(knowledge)
            }

            articleBody.appendChild(sectionDiv)

            //为单词绑定单击事件
            english.querySelectorAll(".word").forEach((el) => {
              el.addEventListener("click", (e) => {
                e.target.classList.add("focusWord")
                this.openPopover(e, e.target.innerText)
              })
            })

            //为短语绑定双击事件
            english.querySelectorAll(".phrase").forEach((el) => {
              el.addEventListener("touchstart", (e) => {
                this.timerTouchstart = setTimeout(() => {
                  this.openPopover(e, el.getAttribute("data"))
                }, 500)
              })

              el.addEventListener("touchmove", () => {
                clearTimeout(this.timerTouchstart)
              })

              el.addEventListener("touchend", () => {
                clearTimeout(this.timerTouchstart)
              })
            })

            //为每句绑定单击事件
            english.querySelectorAll(".sentence-focus").forEach((node1) => {
              node1.addEventListener("click", (ev) => {
                document.querySelectorAll(".content").forEach((node2) => {
                  node2.classList.remove("contentFocus")
                })
                ev.target.parentNode.classList.add("contentFocus")
                this.showFocus()
              })
            })
          })
        }
      })
    },

    saveReadingId() {
      const appointment = this.store.getAppointment()
      this.ajax.post("/record/saveReadingId", {
        aptmId: appointment.aptmId,
        readingId: this.readingId,
      })
    },

    intToStringTime(num) {
      let minutes = parseInt((num / 60).toString())
      let seconds = num % 60
      let strMinutes = minutes < 10 ? "0" + minutes : String(minutes)
      let strSeconds = seconds < 10 ? "0" + seconds : String(seconds)
      return strMinutes + ":" + strSeconds
    },

    //暂时弃用！！！
    unlockButton() {
      setInterval(() => {
        if (this.timerUnlock1 <= 0) {
          this.buttonVisible = true
        }
        this.timerUnlock1--
        this.timerUnlock2++
        this.strTime1 = this.intToStringTime(this.timerUnlock1)
        this.strTime2 = this.intToStringTime(this.timerUnlock2)
      }, 1000)
    },
    fullTextAudioStop() {
      if (this.ossAudioPlayer?.pause) {
        this.ossAudioPlayer.pause()
      }
      this.audioStatus = "end"
      // this.setElementClass("icon-duanlabofang3");
      clearInterval(this.bofangTimer)
    },
    // 设置播放按钮元素类名
    setElementClass(value) {
      const el = document.querySelector(`[data-id="${currentBofangClass.value}"]`)
      const classList = el?.classList
      classList?.remove("icon-duanlabofang3", "icon-duanlabofang2", "icon-duanlabofang1")
      classList?.add(value)
    },
    allSentenceAudioPlay() {
      console.log("allSentenceAudioPlay")
      // return  useDebounceFn(() => {
      const sentenceList = document.querySelectorAll(".section")
      this.fullTextAudioPlay(sentenceList, "fullParaphrase")
      // }, 500);
    },
    fullTextAudioPlay(sentenceList, from) {
      // const paragraphList = document.querySelectorAll(".ai-article-paragraph[paragraph]");
      if (sentenceList.length > 0) {
        let currentIdx = 0
        const paragraphAudioPlay = () => {
          const dom = sentenceList[currentIdx]
          let text = ""
          for (const child of dom.childNodes) {
            if (Array.from(child.classList).includes("english")) {
              const tmp = child.getElementsByClassName("content")
              for (const item of tmp) {
                text += item.textContent
              }
            }
          }
          textToPlayAudio(text.trim(), (url) => {
            let num = 0
            this.fullTextAudioStop()
            this.ossAudioPlayer = new Audio(url)
            this.ossAudioPlayer.oncanplay = () => {
              this.audioStatus = "playing"
              this.ossAudioPlayer.play()
            }
            this.ossAudioPlayer.oncanplaythrough = () => {
              clearInterval(this.bofangTimer)
              this.audioStatus = "playing"
              if (from !== "fullParaphrase") {
                this.bofangTimer = window.setInterval(() => {
                  num = ++num % 3
                  // bofangIcon.value = `icon-duanlabofang${num + 1}`;
                  this.setElementClass(`icon-duanlabofang${num + 1}`)
                }, 300)
              }
            }
            this.ossAudioPlayer.onended = () => {
              if (currentIdx === sentenceList.length - 1) {
                this.audioStatus = "end"
                this.fullTextAudioStop()
              } else {
                currentIdx += 1
                paragraphAudioPlay()
              }
            }
          })
        }
        paragraphAudioPlay()
      }
    },
  },
  beforeUnmount() {
    console.log("onBeforeUnmount")
    this.fullTextAudioStop()
  },
  mounted() {
    this.userinfo = this.store.getUser()
    this.queryReadingArticle()
    if (!this.isReadOrOriginal) {
      this.saveReadingId()
      this.startReadingArticleLearning()
    }
    //倒计时结束完成练习按钮
    //this.unlockButton();
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.title {
  text-align: center;
  font-weight: 700;
}

.titleTranslation {
  margin: 4vw;
  line-height: inherit;
  display: flex;
  justify-content: center;
  //font-size: inherit;
  text-align: center;
}

.topbar img {
  height: 1.6rem;
  width: 1.6rem;
  margin-right: 0.5rem;
}

ion-content {
  --color: black;
}

.essay-generate {
  position: relative;
  height: 100%;
  width: 100%;
  padding-bottom: 3vw;

  ion-content::part(background) {
    background: #fafafa;
  }

  &_bg {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    z-index: -1;
  }

  &_header {
    width: 100%;
    height: 10%;
    padding: 5%;
    background: #fafafa;

    &-title {
      max-width: 60%;

      .title-size {
        font-size: 5vw;
      }
    }

    &-back {
      width: 0.375rem;
      height: 0.6875rem;
      z-index: 10;
    }

    &-bar {
      width: 2.5vw;
      z-index: 10;
    }

    .right-bar {
      &_icon {
        width: 1.4rem;
        height: 1.4rem;
        overflow: hidden;
        position: relative;

        img {
          height: 100%;
          transform: translateX(-2rem);
        }

        .normal-img {
          filter: drop-shadow(2rem 0 0 #3f4140);
        }

        .clicked-img {
          filter: drop-shadow(2rem 0 0 #0dcb8b);
        }
      }

      &_drop {
        width: 1.4rem;
        height: 1.4rem;
        position: relative;

        &_options {
          position: absolute;
          top: 130%;
          left: -100%;
          width: 300%;
          height: 0;
          z-index: 6;
          border-radius: 2vw;
          background-color: #ffffff;
          box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.1);
          overflow-y: scroll;
          transition: height 0.2s ease-in;

          & > span {
            display: block;
            width: 100%;
            height: 100%;
            padding: 10px 11px 11px 8px;
            text-align: center;

            &:hover {
              background-color: #f1fcfa;
            }
          }
        }

        .options_active {
          height: 600%;
          transition: height 0.2s ease-out;
        }
      }
    }
  }

  &_main {
    width: 100%;
    height: 100%;
    border-radius: 3vw;
    overflow-y: scroll;
  }

  &_content {
    flex: 1;
    width: 100%;
    padding: 0 2% 0 2%;
    position: relative;

    &-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 0 5% 5% 5%;
      z-index: -1;
    }

    .essay-place {
      width: 100%;
      display: flex;

      &_content {
        width: 100%;
        height: 100%;
        padding: 3%;
        display: flex;
        //background-color: #D9D9D9;
        border: 2px solid #d9d9d9;
        border-radius: 3vw;
      }
    }
  }

  &_footer {
    width: 100%;
    color: #606266;
    text-align: right;

    &-create {
      &::part(native) {
        background-color: #0bbb7d;
      }
    }

    &-practice {
      width: 60%;

      &::part(native) {
        background-color: #f8ac17;
        width: 40vw;
      }
    }
  }

  &_bottom {
    position: absolute;
    bottom: 5%;
    left: 0;
    width: 100%;
    padding: 5%;

    .hollow {
      height: 9vw;
    }

    .end {
      width: 60%;
      margin: 0 auto 3vw;
      position: relative;

      &-suffix {
        position: absolute;
        right: 0;
        top: -39%;
        width: 20vw;
      }

      &-text {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #ffffff;
      }

      &-suffix-text {
        position: absolute;
        right: 7%;
        top: -32%;
        font-size: 2.2vw;
        color: var(--font-golden-color);
      }
    }
  }
}
</style>

<style>
.popover-examination-option-class {
  --height: 8rem;
  --width: 80vw;
}

.reading-article-main-content {
  //background-color: white;
  color: black;
}

.indent {
  width: 4vw;
  display: inline-block;
}

.english {
  //font-family: 宋体;
  font-size: 1.1em;
  line-height: 1.5rem;
}

.english-font1 {
  font-size: var(--inherit-size);
  line-height: 1.5rem;
}

.english-font2 {
  font-size: 1.25rem;
  line-height: 1.7rem;
}

.english-font3 {
  font-size: 1.4rem;
  line-height: 2rem;
}

.english-font1 h2 {
  font-size: 1.3rem !important;
  line-height: inherit;
}

.english-font2 h2 {
  font-size: 1.45rem !important;
  line-height: inherit;
}

.english-font3 h2 {
  font-size: 1.6rem !important;
  line-height: inherit;
}

.translation {
  line-height: inherit;
  color: #9d9fa6;
  display: none;
  //font-size: inherit;
}

.translation2 {
  line-height: inherit;
  color: #9d9fa6;
  display: none;
}

.translation3 {
  line-height: inherit;
  color: #9d9fa6;
  display: none;
}

.translation-show {
  display: block;
  line-height: 2em;
  //font-size: 1.1em;
}

.sentence-translation {
  font-size: inherit;
}

.course {
  border-bottom: #21c73c dashed;
  display: inline;
}

.focusWord {
  color: white;
  background-color: #21c73c;
}

.knowledge {
  line-height: inherit;
  padding: 2vw;
  display: none;
  border: 1px dashed gray;
}

.knowledge-show {
  display: block;
}

.examination {
  line-height: inherit;
  padding: 2vw;
  display: none;
  border: 1px dashed gray;
}

.examination-show {
  display: block;
}

.examination-number {
  color: red;
  text-decoration: underline;
}

.examination-option {
  color: green;
}

.examination-answer {
  color: purple;
}

.phrase {
  border-bottom: 2px dashed red;
}

.section-flag {
  width: 1.2em;
  height: 1.2em;
}

.sentence-focus {
  width: 1.2em;
  height: 1.2em;
  margin-left: 2vw;
  margin-right: 2vw;
  vertical-align: middle;
  display: none;
}

.sentence-focus-show {
  display: inline;
}

.content {
  height: 1.5rem;
  line-height: inherit;
}

.contentFocus {
  padding: 0 0.5rem;
  height: 1.5rem;
  line-height: inherit;
  color: white;
  background-color: #28ba62;
}

#examination table {
  word-break: break-word;
}

#examination :has(> .examination-answer) {
  word-break: break-word;
}

.audio-play {
  position: absolute;
  right: 3%;
  top: 5rem;
  width: 6%;
  color: var(--text-import-color);
  z-index: 2;

  i {
    font-size: 6vw;
  }
}

.clipboard-copy {
  width: 0;
  height: 0;
  opacity: 0;
  visibility: hidden;
}
</style>
